import script from "./PdfViewerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfViewerPage.vue?vue&type=script&setup=true&lang=js"

import "./PdfViewerPage.vue?vue&type=style&index=0&id=4befd112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4befd112"]])

export default __exports__